import React from 'react'
import Masters_header from './Masters_header'
import { useState, useRef, useEffect } from "react";
import DatePicker from "../DatePicker"
import ReactPaginate from "react-paginate";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from '../../axiosInstance';
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import VendorCreation from '../Masters/VendorCreation'
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';
import { FaExclamationCircle } from 'react-icons/fa';
import plus_circle from "../../assets/svg/plus-circle.svg"
import excel_icon from "../../assets/svg/excel_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';

const Vendor = () => {

  let ModuleId = 6
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [errorData, setErrorData] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');


  const fetchVendors = async (term = '') => {
    try {
      const response = await axiosInstance.get('/vendor/list', {
        params: {
          limit,
          skip,
          search: term || undefined,
        }
      });

      if (response.data.success) {
        setTableData(response.data.vendor || []);
        setTotal(response.data.totalCount || 0);
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      toast.error("Failed to fetch vendors");
      console.error("Error fetching vendors:", error);
    }
  };

  useEffect(() => {
    fetchVendors(searchTerm);
  }, [limit, skip]);

  const handleAddNewClick = () => setIsPopupOpen(true);

  const handleEditClick = async (id) => {
    try {
      const response = await axiosInstance.get(`/vendor/edit/${id}`);
      if (response.data.success) {
        setEditData(response.data.vendor);
        setIsPopupOpen(true);
      }
    } catch (error) {
      toast.error("Failed to fetch vendor details");
      console.error("Error fetching vendor:", error);
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return
    try {
      const response = await axiosInstance.delete(`/vendor/delete/${deleteId}`);
      if (response.data.success) {
        toast.success("Vendor deleted successfully");
        fetchVendors();
      }
    } catch (error) {
      toast.error("Failed to delete vendor");
      console.error("Error deleting vendor:", error);
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  //   const handleBulkDelete = async () => {
  //     try {
  //       // Assuming API supports bulk delete or we need to delete one by one
  //       for (const id of selectedRows) {
  //         await axiosInstance.delete(`/vendor/delete/${id}`);
  //       }
  //       toast.success("Selected vendors deleted successfully");
  //       setSelectedRows([]);
  //       fetchVendors();
  //     } catch (error) {
  //       toast.error("Failed to delete selected vendors");
  //       console.error("Error deleting vendors:", error);
  //     }
  //   };

  const saveVendor = async (vendorData) => {
    try {
      const response = await axiosInstance.post('/vendor/save', vendorData);
      if (response.data.success) {
        toast.success("Vendor saved successfully");
        fetchVendors();
        return true;
      }
    } catch (error) {
      toast.error("Failed to save vendor");
      console.error("Error saving vendor:", error);
      return false;
    }
  };

  const updateVendor = async (vendorData) => {
    try {
      const response = await axiosInstance.put('/vendor/update', vendorData);
      if (response.data.success) {
        toast.success("Vendor updated successfully");
        fetchVendors();
        return true;
      }
    } catch (error) {
      toast.error("Failed to update vendor");
      console.error("Error updating vendor:", error);
      return false;
    }
  };

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    if (selectedRows.length === tableData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(tableData.map(vendor => vendor.id));
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev =>
      prev.includes(id)
        ? prev.filter(rowId => rowId !== id)
        : [...prev, id]
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };


  const handleUploadClick = () => {
    setShowUploadPopup(true);
  };

  const handleCloseUpload = () => {
    setShowUploadPopup(false);
    setSelectedFile(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setSelectedFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  const handleTemplateDownload = async () => {
    try {
      const response = await axiosInstance.get('/vendor/template_download', {
        responseType: 'blob',
      });

      // Try to extract filename from content-disposition header
      const disposition = response.headers['content-disposition'];
      let fileName = 'vendor_template.xlsx';
      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          fileName = match[1].replace(/['"]/g, '');
        }
      }

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Template downloaded successfully");
    } catch (error) {
      toast.error("Failed to download template");
      console.error("Template download error:", error);
    }
  };


  const handleImport = async () => {
    if (!selectedFile) {
      toast.warning("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append('vendor_upload', selectedFile);

    try {
      setLoading(true);
      setErrorData(null); // Reset

      const response = await axiosInstance.post('/vendor/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log("Upload success response:", response.data);
      if (response.data.success) {
        toast.success("Vendor imported successfully");
        setTimeout(() => {
          handleCloseUpload();
        }, 1000)
      } else {
        toast.warning(`${response.data.message}`);
        setErrorData(response.data.error_data);
        handleCloseUpload();
      }
    } catch (error) {
      toast.error(`Import failed: ${error.message}`);
      console.error("Import error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadErrorReport = async () => {
    if (!errorData) return;

    try {
      // Send errorData directly as an object, no need to stringify it
      const response = await axiosInstance.post(
        '/vendor/error_report',
        { data2: errorData },  // Send as an object
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Error_Report.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("Failed to download error report.");
      console.error("Error report download error:", error);
    }
  };
  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchVendors(term);
  };


  return (
    <>
      <Masters_header onSearch={handleSearch} />
      <div className="container">
        {errorData && (
          <div
            onClick={handleDownloadErrorReport}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#FEE2E2',
              color: '#B91C1C',
              padding: '12px 20px',
              borderRadius: '8px',
              fontWeight: '500',
              fontSize: '14px',
              marginTop: '10px',
              marginBottom: '10px',
              cursor: 'pointer',
              gap: '10px',
              width: '100%',
              boxSizing: 'border-box',
              boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
            }}
          >
            <FaExclamationCircle style={{ fontSize: '16px' }} />
            <span style={{ textDecoration: 'underline' }}>
              Click here to download the error report
            </span>
          </div>
        )}
        <div className="header">
          <div className="left-header">
            <h3>Vendor ({total})</h3>
          </div>
          <div className="right-header">
            {isAnySelected ? (
              <button
                id="deleteBtn"
                className="deleteBtn"
                style={{ cursor: 'pointer', margin: '0px' }}
              // onClick={handleBulkDelete}
              >
                Delete
              </button>
            ) : (
              <>
                <button className='jobs-filter-upload-btn' onClick={handleUploadClick} style={{ height: '35px', borderRadius: '6px' }}>Upload</button>

                {showUploadPopup && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                  }}>
                    <div style={{
                      backgroundColor: 'white',
                      padding: '24px',
                      borderRadius: '8px',
                      width: '600px',
                      maxWidth: '90%',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }} ref={popupRef}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px'
                      }}>
                        <h2 style={{ fontSize: '18px', margin: 0 }}>Upload file</h2>
                        <button
                          onClick={handleCloseUpload}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#6B7280'
                          }}
                        >
                          ×
                        </button>
                      </div>

                      <div
                        style={{
                          border: '2px dashed',
                          borderColor: isDragging ? '#3B82F6' : '#D1D5DB',
                          backgroundColor: isDragging ? '#EFF6FF' : 'transparent',
                          borderRadius: '8px',
                          padding: '48px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          cursor: 'pointer',
                          marginBottom: '20px'
                        }}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        <div style={{
                          width: '64px',
                          height: '50px',
                          color: '#9CA3AF',
                          fontSize: '48px'
                        }}>
                          <img style={{ height: '45px' }} src={plus_circle} alt='' />
                        </div>

                        <p style={{ marginBottom: '8px', fontSize: '14px' }}>
                          Drag and drop a file here or{' '}
                          <button
                            type="button"
                            onClick={handleChooseFile}
                            style={{
                              color: '#3B82F6',
                              background: 'none',
                              border: 'none',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              fontSize: '14px'
                            }}
                          >
                            Choose file
                          </button>
                        </p>

                        {selectedFile && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#F3F4F6',
                            padding: '8px 12px',
                            borderRadius: '8px',
                            marginTop: '16px',
                            width: '100%',
                            position: 'relative'
                          }}>
                            {/* File type icon */}
                            <div style={{
                              marginRight: '12px',
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              {selectedFile.name.endsWith('.xlsx') || selectedFile.name.endsWith('.xls') ? (
                                <img src={excel_icon} alt="Excel" style={{ width: '24px', height: '24px' }} />
                              ) : selectedFile.name.endsWith('.csv') ? (
                                <img src="/csv-icon.png" alt="CSV" style={{ width: '24px', height: '24px' }} />
                              ) : (
                                <img src="/file-icon.png" alt="File" style={{ width: '24px', height: '24px' }} />
                              )}
                            </div>

                            {/* File info */}
                            <div style={{ flex: 1 }}>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}>
                                <span style={{ fontSize: '14px', fontWeight: '500' }}>
                                  {selectedFile.name}
                                </span>
                              </div>
                            </div>

                            {/* Remove button */}
                            <button
                              onClick={() => setSelectedFile(null)}
                              style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                background: '#EF4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              ×
                            </button>
                          </div>
                        )}

                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                          accept=".xlsx, .xls, .csv"
                        />
                      </div>

                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}>
                        <button
                          onClick={handleTemplateDownload}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: 'transparent',
                            border: '1px solid #ccc',
                            padding: '8px 16px',
                            borderRadius: '16px',
                            cursor: 'pointer',
                            height: '35px'
                          }}
                        >
                          <img src={download_arrow} alt="Download" /> Template Download
                        </button>

                        <button
                          onClick={handleImport}
                          style={{
                            backgroundColor: '#2563EB',
                            color: '#fff',
                            padding: '8px 16px',
                            borderRadius: '16px',
                            height: '35px',
                            width: '100px',
                            border: 'none',
                            cursor: 'pointer',
                            opacity: !selectedFile || loading ? 0.7 : 1,
                            pointerEvents: !selectedFile || loading ? 'none' : 'auto'
                          }}
                        >
                          {loading ? 'Importing...' : 'Import'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
                  <button id="addNewBtn" onClick={handleAddNewClick}>
                    Add New
                  </button>
                </PermissionWrapper>

              </>
            )}
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                />
              </th>
              <th>S.No</th>
              <th>Vendor Code</th>
              <th>Vendor Name</th>
              <th>Modified Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((vendor, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(vendor.id)}
                    onChange={() => handleRowSelect(vendor.id)}
                  />
                </td>
                <td>{skip + index + 1}</td>
                <td className="table-cell">{vendor.vendor_code}</td>
                <td>{vendor.vendor_name}</td>
                <td>{vendor.modifieddate}</td>
                <td>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "4px 10px",
                      borderRadius: "12px",
                      backgroundColor: vendor.status ? "#d4edda" : "#f8d7da",
                      color: vendor.status ? "#155724" : "#721c24",

                    }}
                  >
                    {/* Dot */}
                    <span
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: vendor.status ? "#28a745" : "#dc3545",
                        display: "inline-block",
                      }}
                    ></span>
                    {vendor.status ? "Active" : "Inactive"}
                  </span></td>
                <td>
                  <div className="actions">
                    <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                      <span
                        className="edit-icon"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleEditClick(vendor.id)}
                      >
                        <img src={Vector} alt="Edit Icon" width="20" height="20" />
                      </span>
                    </PermissionWrapper>

                    <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                      <span
                        className="delete-icon"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteClick(vendor.id)}
                      >
                        <img src={Delete} alt="Delete Icon" width="40" height="40" />
                      </span>
                    </PermissionWrapper>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {searchTerm && tableData.length === 0 && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            No Vendor found matching "{searchTerm}"
          </div>
        )}

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <VendorCreation
              closePopup={closePopup}
              onSubmit={editData ? updateVendor : saveVendor}
              editData={editData}
            />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this Vendor?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  )
}

export default Vendor